(function () {
    'use strict';

    angular
        .module('authentication')
        .controller('SSOCallbackCtrl', SSOCallbackCtrl);

    function SSOCallbackCtrl($location, $state, $rootScope, RemoteService, AuthService, StorageServices, EventManagerService) {
        var vm = this;

        var ref = $location.search().ref;

        if (!ref) {
            $state.go('login');
            return;
        }

        RemoteService.getSSOResult(ref).then(
            function (data) {
                if (data.success) {
                    AuthService.setSSOLoginData(data);
                    $state.go('welcome');
                } else {
                    $rootScope.ssoLoginError = 'SSO authentication failed. Please try again or contact support.';
                    $state.go('login');
                }
            },
            function () {
                $rootScope.ssoLoginError = 'SSO authentication failed. Please try again or contact support.';
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.DO_LOGGED_OUT);
            }
        );
    }
}());
